$(document).on('click',function (event) {
    $(".js-form_select_open").slideUp(100);
    $(".js-form_select_open").removeClass("js-form_select_open");
    $(".js-form_select_icon_up").hide();
    $(".js-form_select_icon_down").show();
});

$(".js-select_label").on('click',function (e) {
    e.preventDefault();
    e.stopPropagation();
    toggleSelect($(this).find(".js-form_select_con"));
});

$(".js-form_select_list_item").on('click',function (e) {
    e.preventDefault();
    $(".js-form_select_list_item").removeClass("form_select_list_item-active");
    var $thisItem = $(this);
    var $thisSelect = $(this).closest(".js-form_select_con");
    $thisSelect.find(".js-form_select_text").text($thisItem.text());
    $thisSelect.siblings(".js-form_select").val($thisItem.data("value"));
    $thisSelect.siblings(".js-form_select").find("option[value='"+$thisItem.data("value")+"']").attr('selected',true);
    $thisItem.addClass("form_select_list_item-active");
});

$(".js-form_select").each(function () {
    var optionSelectedText = $(this).find(":selected").text();
    var optionSelectedValue = $(this).find(":selected").val();
    $(this).siblings(".js-form_select_con").find(".js-form_select_text").text(optionSelectedText);
    $(this).siblings(".js-form_select_con").find(".js-form_select_list_item[data-value='"+optionSelectedValue+"']").addClass("form_select_list_item-active");
});

 function toggleSelect(element) {
    var $thisSelect = element;

    if($thisSelect.find(".js-form_select_list").hasClass("js-form_select_open")){
        $thisSelect.find(".js-form_select_list").slideUp(100);
        $thisSelect.find(".js-form_select_list").removeClass("js-form_select_open");
    }else{
        $thisSelect.find(".js-form_select_list").slideDown(100);
        $thisSelect.find(".js-form_select_list").addClass("js-form_select_open");
    }
    $thisSelect.find(".js-form_select_icon_down").toggle();
    $thisSelect.find(".js-form_select_icon_up").toggle();
}

